import status from '../constants/actionStatus';

export default (state = {
    status: status.PENDING,
    quizList: []
}, action = {}) => {
    switch (action.type) {
    case 'SAVED_QUIZ_REQUEST':
        return {
            status: status.PENDING,
            quizList: []
        };
    case 'SAVED_QUIZ_SUCCESS':
        return {
            status: status.SUCCESS,
            quizList: action.quizList
        };

    case 'TOGGLE_QUIZ__SAVED_SUCCESS': {
        //change state of quiz from list of quiz being shown on screen.
        let quizs = state.quizList;
        let filteredQuizList = quizs.map((quiz) => {
            quiz = { ...quiz };// copy
            if (quiz._id !== action.payload.quizId) {
                return quiz;
            } else {
                //toggle status.
                quiz.isSaved = !quiz.isSaved;
                return quiz;
            }
        });
        filteredQuizList = [ ...filteredQuizList ];
        return {
            status: status.SUCCESS,
            quizList: filteredQuizList
        };
    }
    case 'SAVED_QUIZ_FAILURE':
        return {
            status: status.ERROR,
            quizList: state
        };
    default:
        return state;
    }
};
